import { Button, IconButton } from 'src/components/atoms';
import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const FormDetailPageContainer = styled.div`
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.default};
  padding: 24px;
  width: 100%;
  box-sizing: border-box;
  flex: 1;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
`;

export const FormDetailContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  box-sizing: border-box;
`;

export const FormDetailHeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 40px;
  flex-shrink: 0;
  overflow: hidden;
  box-sizing: border-box;
`;

export const FormDetailBackAndTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;
  min-width: 0;
  height: 40px;
`;

export const FormDetailTitleWithBadge = styled.div`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  flex-shrink: 1;
  min-width: 0;
`;

export const FormDetailBackButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  height: 40px;
  padding-right: 12px;
`;

export const FormDetailTitle = styled.h1`
  margin: 0;
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.headingH1)}
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  height: 38px;
  line-height: 38px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 1;
  min-width: 0;
`;

export const FormDetailActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  flex-shrink: 0;
  height: 40px;
  padding-left: 16px;
`;

const headerIconButtonStyles = `
  && {
    box-sizing: border-box;
    width: 40px;
    height: 40px;
    min-width: 40px;
    min-height: 40px;
    border-radius: 12px;
    padding: 8px;
    flex-shrink: 0;
    cursor: pointer;
  }

  & * {
    cursor: pointer;
  }
`;

export const FormDetailBackButton = styled(IconButton)`
  ${headerIconButtonStyles}

  && {
    background-color: transparent;
    border: none;
  }

  @media (hover: hover) {
    &:hover:not(:disabled) {
      background-color: ${(props) =>
        props.theme.atlas.semantic.color.action.secondary.hoverFill};
    }
  }
`;

export const StyledFormDetailButton = styled(Button)`
  && {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    padding: 8px 12px;
    height: 40px;
    ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.emphasis)};
    font-weight: 600;
    letter-spacing: 0.2px;
  }
`;

export const FormInfoSection = styled.section`
  width: 100%;
`;

export const FormInfoCard = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  gap: 24px;
  background: #f5f5f5;
  border-radius: 12px;
  box-sizing: border-box;
`;

export const FormInfoConfigurationsHeading = styled.h2`
  margin: 0;
  font-family: 'Plus Jakarta Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
  line-height: 28px;
  color: #282e37;
`;

export const FormInfoContentRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
  width: 100%;
`;

export const FormInfoInnerWhiteCard = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  gap: 16px;
  background: #ffffff;
  border-radius: 12px;
  flex: 1;
  box-sizing: border-box;
`;

export const FormInfoCardInner = styled.div`
  display: flex;
  flex-direction: row;
  padding: 0;
  width: 100%;
  gap: 0;
  box-sizing: border-box;
`;

export const FormInfoLeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0;
  gap: 0;
  flex: 1;
  box-sizing: border-box;
`;

export const FormInfoRightColumn = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0;
  gap: 12px;
  flex: 1;
  box-sizing: border-box;
`;

export const FormInfoListItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 12px 0;
  gap: 12px;
  isolation: isolate;
  position: relative;
  width: 100%;
  box-sizing: border-box;

  &:first-child {
    padding-top: 12px;
  }

  &:last-child {
    padding-bottom: 12px;
  }
`;

export const FormInfoListItemLabel = styled.span`
  font-family: 'Plus Jakarta Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.2px;
  color: #282e37;
  flex: 1;
  min-width: 0;
  padding-top: 2px;
`;

export const FormInfoListItemValue = styled.div`
  font-family: 'Plus Jakarta Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.2px;
  color: #282e37;
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 2px;
`;

export const FormInfoListItemDivider = styled.div`
  position: absolute;
  height: 1px;
  left: 0;
  right: 0;
  bottom: 0;
  background: #dadada;
  flex: none;
  order: 1;
  flex-grow: 0;
  z-index: 1;
`;

export const FormInfoConfigurationsColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const FormInfoConfigurationsStack = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FormInfoFieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
`;

export const FormInfoDivider = styled.div`
  width: 100%;
  height: 1px;
  flex-shrink: 0;
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.ui.divider.default};
`;

export const FormInfoMetaColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FormInfoCardTitle = styled.h3`
  margin: 0;
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.body)}
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
`;

export const FormInfoCountryTitle = styled.h3`
  margin: 0;
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.headingH3)}
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
`;

export const FormInfoRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const FormInfoLabel = styled.span`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.body)}
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
`;

export const FormInfoValue = styled.span`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  overflow-wrap: break-word;
  word-break: break-word;
`;

export const FormInfoDescription = styled.div<{
  $isEmpty?: boolean;
  $truncated?: boolean;
}>`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  line-height: 24px;
  width: 100%;
  min-width: 0;
  overflow-wrap: break-word;
  word-break: break-word;

  ${(p) =>
    p.$isEmpty
      ? `
    min-height: 0;
    margin: 0;
    padding: 0;
    display: block;
  `
      : `
    display: block;
    min-height: 0;
  `}

  ${(p) =>
    p.$truncated &&
    `
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  `}

  p {
    margin: 0;
  }
`;

export const FormInfoShowMore = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin-top: 4px;
  color: ${(props) => props.theme.atlas.semantic.color.action.primary.default};
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  cursor: pointer;
  text-decoration: underline;
  width: fit-content;
  align-self: flex-start;
  font-weight: 400;
  outline: none;

  &:hover {
    font-weight: 600;
  }

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: 2px solid
      ${(props) => props.theme.atlas.semantic.color.ui.focusRing};
    outline-offset: 2px;
  }
`;

export const FormInfoCreatedByRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

export const FormInfoCategoryPill = styled.span`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.variant};
  padding: 4px 12px;
  border-radius: 999px;
  border: none;
  display: inline-block;
  width: fit-content;
`;

export const FormInfoSubsection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const FormInfoTwoColumnRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  @media (max-width: 700px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`;

export const FormInfoThreeColumnRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 24px;
  @media (max-width: 700px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`;

export const FormInfoLanguagePills = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
`;

export const FormInfoIntakeChannelsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const FormInfoIntakeChannelRow = styled.div<{ $nested?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0;
  gap: 12px;
  width: 100%;
  box-sizing: border-box;
  padding-left: ${(p) => (p.$nested ? '16px' : '0')};
`;

export const FormInfoIntakeChannelToggleLabel = styled.span<{
  $enabled?: boolean;
}>`
  flex: 1 1 0;
  min-width: 0;
  font-family: 'Plus Jakarta Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.2px;
  color: ${(props) => (props.$enabled ? '#282e37' : '#a0a2a5')};
`;

export const FormInfoMetaDatesRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
  box-sizing: border-box;

  & > * {
    flex: 1 1 0;
    min-width: 0;
  }

  @media (max-width: 700px) {
    flex-direction: column;
  }
`;

export const FormDetailEmptyWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 48px 0;
`;

export const FormDetailLoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 320px;
  width: 100%;
`;
